import React, { Component } from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpJobSearchParams from './TpJobSearchParams';
import TpJobService from '../../../Services/TpJobService';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ProjectTpJobItem from '../../../Domain/ProjectTpJobItem';
import ProjectTpJobSearchParams from './ProjectTpJobSearchParams';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ExcludedTpJobItem from '../../../Domain/ThirdParty/TpJob/ExcludedTpJobItem';
import AllTpJobItem from '../../../Domain/ThirdParty/TpJob/AllTpJobItem';
import UninvoiceableTpJobItem from '../../../Domain/ThirdParty/TpJob/UninvoiceableTpJobItem';
import ReadyForInvoicingTpJobItem from '../../../Domain/ThirdParty/TpJob/ReadyForInvoicingTpJobItem';
import TpJobItem from '../../../Domain/ThirdParty/TpJob/TpJobItem';
import EditProjectTpJobWindowDescription from './EditProjectTpJobWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import ShowTpJobEvaluatorPaymentsOverDataWindow from '../../ThirdParty/TpEvaluatorTpJobPayments/ThirdPartyJobPayments/ShowTpJobEvaluatorPaymentsOverDataWindow';
import EditTpClientInvoiceWindowDescription from '../TpClientInvoice/EditTpClientInvoiceWindowDescription';
import contactService from '../../../Services/contactService';
import ProjectAssignmentService from '../../../Services/ProjectAssignmentsService';
import TpClientInvoiceItem from '../../../Domain/TpClientInvoiceItem';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ClientInvoiceFormOptionsArray from '../../../Enums/ClientInvoiceFormOptionsArray';
import ClientService from '../../../Services/clientService';
import AddToTpClientInvoicePanel from './AddToTpClientInvoicePanel';
import TpEvaluatorRelatedTpJobItem from '../../../Domain/ThirdParty/TpJob/TpEvaluatorRelatedTpJobItem';
import ClientReadyForInvoicingTpJobItem from '../../../Domain/ThirdParty/TpJob/ClientReadyForInvoicingTpJobItem';
import ProjectTpJobEditItem from '../../../Domain/ThirdParty/Project/ProjectTpJobEditItem';
import paidOutsideOfSystemHelper from '../../../Helpers/paidOutsideOfSystemHelper';

const exportMessage =
  'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

export default class TpJobAdmin extends Component {
  static defaultProps = {
    SearchType: '',
    tpEvaluatorId: null,
    tpEvaluatorLinkId: null,
  };

  constructor(props) {
    super(props);

    const searchItem = props.ProjectId || props.ClientId ? new ProjectTpJobSearchParams() : new TpJobSearchParams();

    if (props.ProjectId || props.ClientId) {
      searchItem.SearchType = props.SearchType;

      if (props.ProjectId) {
        searchItem.ProjectId = props.ProjectId;
      }

      if (props.ClientId) {
        searchItem.ClientId = props.ClientId;
      }
    }

    if (props.tpEvaluatorId) {
      searchItem.TpEvaluatorId = props.tpEvaluatorId;
    }

    if (props.tpEvaluatorLinkId) {
      searchItem.TpEvaluatorLinkId = props.tpEvaluatorLinkId;
    }

    // Deep-link seed for global record search (CD-5425), seeded on the primary key the palette
    // displayed so the grid lands on that one row. Guarded on the embedded props: when this page is
    // rendered inside a project or client it is already scoped, and a stray url parameter must not
    // widen or fight that. content.js renders a deep-linked page with no props at all, so the
    // standalone case is exactly the propless one.
    if (!props.ProjectId && !props.ClientId) {
      const seededTpJobId = new URLSearchParams(window.location.search).get('TpJobId');

      if (seededTpJobId) {
        searchItem.TpJobId = seededTpJobId;
      }
    }

    this.state = {
      searchItem,
      itemList: [],
      shownPanel: ShownPanelsEnum.None,
    };

    this.startSearch = this.startSearch.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    TpJobItem.clickOnSelect = this.clickOnSelect.bind(this);
    TpJobItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    TpJobItem.selectedStatus = this.selectedStatus.bind(this);
    EditProjectTpJobWindowDescription.getSelected = this.getSelected.bind(this);
    EditProjectTpJobWindowDescription.getSearchParameters = this.getSearchParameters.bind(this);
    EditProjectTpJobWindowDescription.getAllItemsInTheSearchAreSelected =
      this.getAllItemsInTheSearchAreSelected.bind(this);
    this.clickOnUpdateMultipleButton = this.clickOnUpdateMultipleButton.bind(this);
    TpJobItem.tpJobPaymentsFunction = this.tpJobPaymentsFunction.bind(this);
    TpJobItem.paidOutsideOfSystemFunction = this.paidOutsideOfSystemFunction.bind(this);
    this.closeOverWindow = this.closeOverWindow.bind(this);
    this.clickOnAddToInvoiceButton = this.clickOnAddToInvoiceButton.bind(this);
    this.clickOnGenerateInvoiceButton = this.clickOnGenerateInvoiceButton.bind(this);
    this.clickOnGenerateAssignmentPayment = this.clickOnGenerateAssignmentPayment.bind(this);
    this.clickOnOkGeneratePayment = this.clickOnOkGeneratePayment.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  tpJobPaymentsFunction(tpJob) {
    this.setState({ extendedLoading: true });
    // const assignmentData = await AssignmentService.GetAssignmentById(assignment.AsId);
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.EvaluatorPayments,
      selectedTpJob: tpJob,
      // selectedItemExtended: assignmentData,
      // extendedLoading: false,
    });
  }

  closeOverWindow() {
    this.setState({ shownOverWindow: ShownOverWindowsEnum.None });
  }

  // CD-5421: the single-row toggle. Posts through the same bulk endpoint with a one-element id list, so
  // there is only one write path and one server-side eligibility check.
  paidOutsideOfSystemFunction(tpJob) {
    const turningOn = !TpJobItem.isPaidOutsideOfSystem(tpJob);
    const message = paidOutsideOfSystemHelper.GetToggleConfirmationMessage(
      turningOn,
      'job',
      tpJob.ThirdPartyJobId,
      'evaluator fee'
    );

    ErrorMessage.SetApprove(message, () => this.applyPaidOutsideOfSystem(tpJob, turningOn));
  }

  applyPaidOutsideOfSystem(tpJob, paidOutsideOfSystem) {
    TpJobService.EditMultiple(
      ProjectTpJobEditItem.createPaidOutsideOfSystemItem(paidOutsideOfSystem),
      [tpJob],
      false,
      this.getSearchParameters()
    )
      .then(() => {
        this.refresh();
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: TPJA5421');
      });
  }

  renderOverWindows() {
    if (this.state.shownOverWindow === ShownOverWindowsEnum.EvaluatorPayments) {
      return (
        <ShowTpJobEvaluatorPaymentsOverDataWindow
          tpJob={this.state.selectedTpJob}
          clickOnCancel={this.closeOverWindow}
        />
      );
    }

    return null;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  getSearchParameters(searchItem = null) {
    searchItem = searchItem ? searchItem : this.state.searchItem;
    if (this.props.ProjectId || this.props.ClientId) {
      searchItem.SearchType = this.props.SearchType;

      if (this.props.ProjectId) {
        searchItem.ProjectId = this.props.ProjectId;
      }

      if (this.props.ClientId) {
        searchItem.ClientId = this.props.ClientId;
      }
    }

    if (this.props.tpEvaluatorId) {
      searchItem.TpEvaluatorId = this.props.tpEvaluatorId;
    }

    if (this.props.tpEvaluatorLinkId) {
      searchItem.TpEvaluatorLinkId = this.props.tpEvaluatorLinkId;
    }

    return { ...searchItem };
  }

  getAllItemsInTheSearchAreSelected() {
    return this.state.allItemsInTheSearchAreSelected;
  }

  selectedStatus() {
    return !this.state.itemList.some((x) => x.Selected === false);
  }

  clickOnSelect(item) {
    const updatedList = this.state.itemList.map((element) => {
      if (element.TpJobId === item.TpJobId) {
        return {
          ...element,
          Selected: !element.Selected,
        };
      }
      return element;
    });

    this.setState({
      itemList: updatedList,
    });
  }

  selectAllElements() {
    const selectedStatus = this.state.itemList.some((item) => item.Selected === false);
    const templist = [...this.state.itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ itemList: templist });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: this.getSearchParameters(searchItem) });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem }, shownPanel: ShownPanelsEnum.None });
  }

  renderButtonsAndPanels() {
    if (this.props.tpEvaluatorId || this.props.tpEvaluatorLinkId) {
      return null;
    }

    return (
      <ButtonRow
        labels={['Export Orphaned']}
        colors={[ButtonColorsEnum.Primary]}
        keys={[ShownPanelsEnum.AddNewItem]}
        icons={['fa-regular fa-file-excel']}
        roleKeys={['createofficeoverheadbutton']}
        value={this.state.shownPanel}
        onClick={() => this.handleExportOnClick()}
      />
    );
  }

  handleExportOnClick() {
    ErrorMessage.SetApprove(
      <span>
        <p>You are about to export all the orphaned jobs.</p>
        <p>Are you sure you want to proceed with the export?</p>
      </span>,
      () => this.startExport()
    );
  }

  startExport() {
    TpJobService.ExportThirdPartyOrphanedJobsToExcel().catch(() => ErrorMessage.SetErrorMessage('TJA58'));
    ErrorMessage.SetSuccessWithWait(exportMessage);
  }

  handleExportExcelButtonClick() {
    TpJobService.ExportAdminExcelAsync(this.state.searchItem).catch(() => ErrorMessage.SetErrorMessage('TJA66'));
    ErrorMessage.SetSuccessWithWait(exportMessage);
  }

  isAnyItemSelected() {
    return this.state.itemList.find((u) => u.Selected === true) !== undefined;
  }

  clickOnUpdateMultipleButton(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  clickOnGenerateAssignmentPayment() {
    ErrorMessage.SetApprove(
      `You are about to generate assignment payment for ${this.getSelected()?.length} assignment(s).`,
      this.clickOnOkGeneratePayment.bind(this)
    );
  }

  clickOnOkGeneratePayment() {
    ErrorMessage.SetNotification(
      'The assignment payment generation process is running in the background. You will receive a message about the result as soon as it has been finished. '
    );
    TpJobService.GenerateAssignmentPayment(
      [...this.getSelected().map((s) => s.TpJobId)],
      this.getSearchParameters(),
      this.getAllItemsInTheSearchAreSelected()
    )
      .then(() => {
        this.refresh();
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: EAL147');
      });
  }

  clickOnGenerateInvoiceButton() {
    // The invoice form is shared with the Third-Party Client Invoices page, so the ticked jobs travel on the
    // invoice item itself; a hook on the form would outlive this list and leak into a later Copy there.
    const ticked = {
      TpJobIds: this.getSelected().map((job) => job.TpJobId),
      AllItemsInTheSearchSetAreSelected: this.getAllItemsInTheSearchAreSelected() === true,
      JobSearchParameters: this.getSearchParameters(),
    };
    ClientService.GetById(this.props.ClientId)
      .then((result) => {
        const clientInvoice = new TpClientInvoiceItem();
        Object.assign(clientInvoice, ticked);
        clientInvoice.CaspianClientId = result.clientId;
        clientInvoice.CaspianClientName = result.name;
        clientInvoice.OfficeName = result.officeName;
        clientInvoice.OfficeId = result.officeId;
        clientInvoice.DaysToPay = result.daysToPayCode ? result.daysToPayCode : 30;
        clientInvoice.LatePaymentInterestRate = result.invoiceInterestRate ? result.invoiceInterestRate : 0;
        if (clientInvoice.OfficeId === 9)
          clientInvoice.FulfillmentDate = dateTimeHelper.addDaysToDate(dateTimeHelper.toYYYYsMMsDD(new Date()), 2);

        contactService
          .GetContactListByClientId(clientInvoice.CaspianClientId, true)
          .then((contacts) => {
            clientInvoice.ClientContacts = contacts;

            ProjectAssignmentService.GetProjectAssignmentAdditionalInformation(clientInvoice.CaspianClientId)
              .then((result) => {
                clientInvoice.DefaultReportName = ClientInvoiceFormOptionsArray.find(
                  (f) => f.label === result.ciDefaultReportName
                ).value;
                clientInvoice.CurrencyId = result.billingCurId;

                this.setState({
                  selectedItem: clientInvoice,
                  shownPanel: ShownPanelsEnum.GenerateInvoice,
                });
              })
              .catch((error) => ErrorMessage.SetErrorMessage('CA134', error));
          })
          .catch((error) => ErrorMessage.SetErrorMessage('CA146', error));
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA146', error));
  }

  clickOnAddToInvoiceButton() {
    this.setState({
      shownPanel: ShownPanelsEnum.AddNewParent,
    });
  }

  renderActionButtons() {
    if (this.props.tpEvaluatorId || this.props.tpEvaluatorLinkId) {
      return null;
    }

    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-rectangle-history-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnUpdateMultipleButton(this.state.selected, this.state.selectedItem),
            tooltip: 'Update Multiple',
            roleKey: 'assignment_edit',
            hidden: ['excluded', 'all'].includes(this.props.SearchType),
          },
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-file-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnAddToInvoiceButton,
            tooltip: 'Add To Invoice',
            roleKey: 'assignment_edit',
            hidden: ['uninvoiceable', 'excluded', 'all'].includes(this.props.SearchType),
          },
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-rectangle-history-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: this.clickOnGenerateInvoiceButton,
            tooltip: 'Generate Invoice',
            roleKey: 'assignment_edit',
            hidden: ['uninvoiceable', 'excluded', 'all'].includes(this.props.SearchType),
          },
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-file-circle-xmark',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnUpdateMultipleButton(this.state.selected, this.state.selectedItem),
            tooltip: 'Mark As Uninvoiceable',
            roleKey: 'assignment_edit',
            hidden: this.props.SearchType !== 'excluded',
          },
          {
            disabled: !this.isAnyItemSelected(),
            iconName: 'fa-solid fa-file-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnGenerateAssignmentPayment(),
            tooltip: 'Generate Assignment Payment',
            roleKey: 'assignment_edit',
            hidden: this.props.SearchType !== 'excluded',
          },
        ]}
      />
    );
  }

  changeOfItemListFunction(itemList) {
    this.setState({
      itemList,
    });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditProjectTpJobWindowDescription}
            errorCode={'TPJA232'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.GenerateInvoice,
          <GeneralEditWizzardBase
            editedItem={this.state.selectedItem}
            crudType={CrudTypesEnum.Create}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={EditTpClientInvoiceWindowDescription}
            errorCode={'TPJA232'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewParent,
          <AddToTpClientInvoicePanel
            clientId={this.props.ClientId}
            selected={this.getSelected()}
            allItemsInTheSearchAreSelected={this.getAllItemsInTheSearchAreSelected()}
            searchParameters={this.getSearchParameters()}
            refresh={this.refresh}
          />
        )}
      </div>
    );
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: refresh,
    });
    if (refresh) {
      this.refresh();
    }
  }

  savePanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    this.refresh();
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderOverWindows()}
        {!this.props.ProjectId && !this.props.ClientId && this.renderButtonsAndPanels()}
        {(this.props.ProjectId || this.props.ClientId) && this.renderActionButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          clickOnStartSearch={this.startSearch}
          searchParamsType={this.props.ProjectId || this.props.ClientId ? ProjectTpJobSearchParams : TpJobSearchParams}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          serviceFunction={TpJobService.GetAllItemsBySearching}
          convertDBItemsFunction={TpJobService.ConvertDBItems}
          type={this.getItemType()}
          popupEnabled={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in IDs, source, names...'
          errorCode='TPJA85'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='reports_tpjobs'
          excelExportTooltipMessage='Export to Excel based on search parameters'
          forceClearCacheOnSearch={true}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchAreSelected) => {
            this.setState({ allItemsInTheSearchAreSelected });
          }}
          enableUrlPush={!this.props.ProjectId && !this.props.ClientId}
          // Every embedded context scopes the list to an entity the user cannot type in the
          // filter panel, so clearing has to go through getSearchParameters (which re-applies
          // that scope) instead of the panel resetting the parameters on its own - otherwise
          // Clear all + Search lists every job in the system.
          useClickOnClearAll={
            this.props.ProjectId || this.props.ClientId || this.props.tpEvaluatorId || this.props.tpEvaluatorLinkId
          }
        />
      </div>
    );
  }

  getItemType() {
    if (this.props.tpEvaluatorId || this.props.tpEvaluatorLinkId) {
      return TpEvaluatorRelatedTpJobItem;
    }

    if (this.props.ClientId && !this.props.ProjectId && this.props.SearchType === 'finalized') {
      return ClientReadyForInvoicingTpJobItem;
    }

    return this.props.ProjectId || this.props.ClientId
      ? this.props.SearchType === 'finalized'
        ? ReadyForInvoicingTpJobItem
        : this.props.SearchType === 'uninvoiceable'
        ? UninvoiceableTpJobItem
        : this.props.SearchType === 'excluded'
        ? ExcludedTpJobItem
        : this.props.SearchType === 'all'
        ? AllTpJobItem
        : ProjectTpJobItem
      : TpJobItem;
  }
}
